<template>
    <div class="mobile-sidebar p-3">
        <div class="d-flex justify-content-between mb-4">
            <div class="ml-2">
                <i class="fa-solid fa-caret-left pr-2 navigator-caret" />
                <a :href="route('crypto-book')"
                   class="navigator">
                    <Translate translationKey="crypto-book.handbookCoverPage"
                               fallback="Handbook Cover Page" />
                </a>
            </div>
            <button class="nav-close navbar-toggler navbar-toggle text-white"
                    type="button"
                    @click="close">
                <i class="fa-solid fa-xmark" />
            </button>
        </div>
        <div id="accordion">
            <div v-for="chapter in chapterList"
                 :key="chapter.id"
                 class="mb-5">
                <div class="chapter-title d-flex ml-2 pt-3">
                    <div v-if="chapter.crypto_book_sections.length > 0"
                         class="chapter-title-text text-decoration-none pl-3 py-2">
                        <Translate translationKey="crypto-book.chapterIdWithTitle"
                                   :replacements="{ id: chapter.id, title: chapter.title }"
                                   :fallback="`Chapter ${chapter.id}: ${chapter.title}`"
                                   has-html-tags />
                    </div>
                    <div v-else
                         class="chapter-title-text pl-3 py-2">
                        <span>
                            <Translate translationKey="crypto-book.chapterIdWithTitle"
                                       :replacements="{ id: chapter.id, title: chapter.title }"
                                       :fallback="`Chapter ${chapter.id}: ${chapter.title}`"
                                       has-html-tags />
                        </span>
                        <br>
                    </div>
                </div>
                <div class="ml-2 pl-4 pt-4 pb-3 text-left chapter-img">
                    <div class="position-relative">
                        <img :alt="chapter.title"
                             :src="asset_cdn(chapter.image_url, 315)"
                             class="w-100 p-0 pt-2 pl-2">
                        <span v-if="chapter.crypto_book_sections.length < 1"
                              class="badge-coming-soon-sb">
                            <Translate translationKey="crypto-book.coming-soon"
                                       fallback="Coming soon" />
                        </span>
                    </div>
                </div>
                <div class="ml-2">
                    <ul v-if="chapter.id === 10"
                        class="accordion list-unstyled mb-0">
                        <li class="mt-0 ml-4 pl-1 pb-1 mb-0 mr-0">
                            <a :href="route('crypto-book-glossary')"
                               class="nav-link pr-0">
                                <div class="row flex-nowrap justify-content-start">
                                    <div class="text-left pr-3">10.1</div>
                                    <div class="text-left px-0">
                                        <Translate translationKey="crypto-book.allCryptoTerms"
                                                   fallback="All Crypto Terms" />
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <ul v-if="chapter.id !== 10"
                        class="accordion list-unstyled mb-0">
                        <li class="mt-0 pl-2 mr-0">
                            <a v-for="(section, index) in chapter.crypto_book_sections"
                               :key="section.slug"
                               :class="currentSection === section.slug ? 'active' : ''"
                               :href="`${route('crypto-book')}/${section.slug}`"
                               class="nav-link pb-2">
                                <div class="row flex-nowrap justify-content-start">
                                    <div class="text-left pr-3">
                                        {{ chapter.id }}.{{ index + 1 }}
                                    </div>
                                    <div class="text-left px-0">
                                        {{ section.title }}
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <ul v-else
                        class="accordion alphabet list-unstyled mb-0 pl-2">
                        <li class="pt-1 mt-0 ml-3 mr-0">
                            <a :class="currentChapter === '1' ? 'active-letter' : ''"
                               class="btn"
                               :href="`${route('crypto-book-glossary')}#numbers`">
                                #
                            </a>
                            <a v-for="letter in letters"
                               :key="letter"
                               :class="currentChapter === letter ? 'active-letter' : ''"
                               class="btn"
                               :href="`${route('crypto-book-glossary')}#${letter.toLowerCase()}`">
                                {{ letter.toUpperCase() }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { asset_cdn, route } from '@/js/helpers/helpers';

    export default {
        name: 'Sidebar',
        props: {
            chapterList: {
                type: Array,
                default() {
                    return [];
                },
            },
            currentChapter: {
                type: String,
                default: '',
            },
            currentSection: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                letters: [
                    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n',
                    'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
                ],
            };
        },
        methods: {
            close() {
                this.$emit('closeMobileSidebar');
            },
            route,
            asset_cdn,
        },
    };
</script>

<style scoped lang="scss">
.mobile-sidebar .btn {
    padding: 6px !important;
}

@media (max-width: 1024px) {
    .crypto-book .content ul li {
        margin: 0 !important;
        margin-left: 24px !important;
    }
}
</style>
